import { render, staticRenderFns } from "./Bylaw.vue?vue&type=template&id=46d50481&scoped=true"
import script from "./Bylaw.vue?vue&type=script&lang=js"
export * from "./Bylaw.vue?vue&type=script&lang=js"
import style0 from "./Bylaw.vue?vue&type=style&index=0&id=46d50481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d50481",
  null
  
)

export default component.exports